import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useGenresService } from '@/flight-deck-api/services/genres.service'

/**
 * Hook for fetching available genres
 * @returns Genres data, loading state, and errors
 */
export const useGenres = () => {
  const { getGenres } = useGenresService()

  const {
    data: genresResponse,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['genres'],
    // biome-ignore lint/plugin: RETIRED, do not copy. Call it through useSelectQuery/useSelectMutation when touching this.
    queryFn: () => getGenres.handler(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  })

  const genres = useMemo(
    () =>
      genresResponse?.data?.map(genre => ({
        id: String(genre.programGenreId),
        name: genre.name,
      })) || [],
    [genresResponse],
  )

  return {
    genres,
    isLoading,
    error,
    refetch,
  }
}
